/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { replace as e } from "../../core/string.js";
var s = [{
  pattern: /^\s*(https?:\/\/([^\s]+))\s*$/i,
  target: "_blank",
  label: "{messages.view}"
}, {
  pattern: /^\s*(tel:([^\s]+))\s*$/i,
  label: "{hierPart}"
}, {
  pattern: /^\s*(mailto:([^\s]+))\s*$/i,
  label: "{hierPart}"
}, {
  pattern: /^\s*(arcgis-appstudio-player:\/\/([^\s]+))\s*$/i,
  label: "{messages.openInApp}",
  appName: "App Studio Player"
}, {
  pattern: /^\s*(arcgis-collector:\/\/([^\s]+))\s*$/i,
  label: "{messages.openInApp}",
  appName: "Collector"
}, {
  pattern: /^\s*(arcgis-explorer:\/\/([^\s]+))\s*$/i,
  label: "{messages.openInApp}",
  appName: "Explorer"
}, {
  pattern: /^\s*(arcgis-navigator:\/\/([^\s]+))\s*$/i,
  label: "{messages.openInApp}",
  appName: "Navigator"
}, {
  pattern: /^\s*(arcgis-survey123:\/\/([^\s]+))\s*$/i,
  label: "{messages.openInApp}",
  appName: "Survey123"
}, {
  pattern: /^\s*(arcgis-trek2there:\/\/([^\s]+))\s*$/i,
  label: "{messages.openInApp}",
  appName: "Trek2There"
}, {
  pattern: /^\s*(arcgis-workforce:\/\/([^\s]+))\s*$/i,
  label: "{messages.openInApp}",
  appName: "Workforce"
}, {
  pattern: /^\s*(iform:\/\/([^\s]+))\s*$/i,
  label: "{messages.openInApp}",
  appName: "iForm"
}, {
  pattern: /^\s*(flow:\/\/([^\s]+))\s*$/i,
  label: "{messages.openInApp}",
  appName: "FlowFinity"
}, {
  pattern: /^\s*(lfmobile:\/\/([^\s]+))\s*$/i,
  label: "{messages.openInApp}",
  appName: "Laserfische"
}, {
  pattern: /^\s*(mspbi:\/\/([^\s]+))\s*$/i,
  label: "{messages.openInApp}",
  appName: "Microsoft Power Bi"
}];

function a(e) {
  var a = null;
  return s.some(function (s) {
    return s.pattern.test(e) && (a = s), !!a;
  }), a;
}

function p(s, p) {
  if ("string" != typeof p || !p) return p;
  var r = a(p);
  if (!r) return p;
  var t = p.match(r.pattern),
      n = t && t[2],
      l = e(e(r.label, {
    messages: s,
    hierPart: n
  }), {
    appName: r.appName
  }),
      i = r.target ? " target=\"".concat(r.target, "\"") : "",
      o = "_blank" === r.target ? ' rel="noreferrer"' : "";
  return p.replace(r.pattern, "<a".concat(i, " href=\"$1\"").concat(o, ">").concat(l, "</a>"));
}

export { p as autoLink };